import type { Page } from '@/domain/model/Page';
import type { Sector, UpsertSectorCommand } from '@/domain/model/Sector';
import type { SectorGateway, ListSectorsParams } from '@/application/port/out/SectorGateway';
import type {
  ListSectorsUseCase, GetSectorUseCase, CreateSectorUseCase,
  UpdateSectorUseCase, DeactivateSectorUseCase,
} from '@/application/port/in/SectorUseCase';

export class ListSectors implements ListSectorsUseCase {
  constructor(private readonly g: SectorGateway) {}
  execute(params: ListSectorsParams): Promise<Page<Sector>> { return this.g.list(params); }
}
export class GetSector implements GetSectorUseCase {
  constructor(private readonly g: SectorGateway) {}
  execute(id: string): Promise<Sector> { return this.g.get(id); }
}
export class CreateSector implements CreateSectorUseCase {
  constructor(private readonly g: SectorGateway) {}
  execute(cmd: UpsertSectorCommand): Promise<Sector> { return this.g.create(cmd); }
}
export class UpdateSector implements UpdateSectorUseCase {
  constructor(private readonly g: SectorGateway) {}
  execute(id: string, cmd: UpsertSectorCommand): Promise<Sector> { return this.g.update(id, cmd); }
}
export class DeactivateSector implements DeactivateSectorUseCase {
  constructor(private readonly g: SectorGateway) {}
  execute(id: string): Promise<Sector> { return this.g.deactivate(id); }
}
